import {
  Copy,
  Flex,
  Heading,
  Image,
  Link,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React, { useEffect } from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { statesContent } from 'src/components/selfService/features/Signup/steps/ValidationStep/constants';
import { durationVital } from 'src/common/telemetry/DataDog/datadogRumApi';
import { BALANCE_ACCOUNT_INIT_DURATION_VITAL_NAME } from 'src/components/selfService/common/Balance/constants/balanceConstants';
import { DurationVitalStatus } from 'src/types/datadogRumApi';

export function PendingState(): JSX.Element {
  const { pending } = statesContent;

  const { isPhone } = useScreenSizes();
  const textAlign = isPhone ? 'left' : 'center';

  useEffect(() => {
    durationVital(BALANCE_ACCOUNT_INIT_DURATION_VITAL_NAME)?.stop({
      options: {
        context: { status: DurationVitalStatus.SUCCESS },
      },
    });
  }, []);

  return (
    <>
      <Stack y="sm" alignSelf="center">
        <Image
          width="250px"
          src={pending.illustrationUrl}
          alt=""
          role="presentation"
        />
      </Stack>
      <Stack y="sm">
        <Heading variant="h1" textAlign={textAlign}>
          {pending.title}
        </Heading>
      </Stack>
      <Stack y="md">
        <Copy variant="body" textAlign={textAlign} display="inline-block">
          {pending.text[0]}{' '}
          <Link
            variant="muted"
            href={pending.termsOfServiceLinkUrl}
            target="_blank"
          >
            {pending.termsOfServiceLinkText}
          </Link>
          {pending.text[1]}
        </Copy>
      </Stack>
      {pending.list.map((bulletItem) => (
        <Stack y="x-sm" key={bulletItem.text}>
          <Flex alignItems="center">
            <Stack x="x-sm">
              <Image
                width="16px"
                height="16px"
                src={bulletItem.icon}
                alt=""
                role="presentation"
              />
            </Stack>
            <Copy variant="caption" color="secondaryText" textAlign={textAlign}>
              {bulletItem.text}
            </Copy>
          </Flex>
        </Stack>
      ))}
    </>
  );
}
